export default __webpack_public_path__ + "icon-social-media-facebook-rollover.b373ddff5933d4c18fcb.svg";